







































































































































































































import Vue from 'vue'
import _ from 'lodash'
// @ts-ignore
import { AgGridVue } from 'ag-grid-vue'
import { ProductTextLanguage, UiLanguageItem, UiLanguageList } from '@/types'
import { SecurityArea, SecurityComponent, SnackbarStateEnum } from '@/types/enums'
import { TranslateResult } from 'vue-i18n'
import { hexToRgba } from '@/services/hex-to-rgba'
import { GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import ProgressCircular from '@/components/ProgressCircular.vue'
import * as securityService from '@/services/security-service'
import { ProductGroup } from '@/model/products/ProductGroup'
import {
  AddProductResponse,
  GetProductDescriptionResponse, GetProductNoticesResponse,
  GetProductTextsResponse, ProductDescriptionItemResponse, ProductNoticeResponse, ProductSubstituteResponse,
  ProductText,
  ProductTextArtResponse, ProductUnitResponse, ResponseBase
} from '@/types/service-response'
import {
  COPY_PRODUCT,
  CREATE_PRODUCT, DELETE_PRODUCT,
  FETCH_PRODUCT_DESCRIPTION_TEXTS, FETCH_PRODUCT_NOTICES, FETCH_PRODUCT_SUBSTITUTE,
  FETCH_PRODUCT_TEXT_ART_LIST,
  FETCH_PRODUCT_TEXTS, FETCH_PRODUCT_UNIT_LIST, UPDATE_PRODUCT,
  UPDATE_PRODUCT_DESCRIPTION_TEXTS, UPDATE_PRODUCT_NOTICES, UPDATE_PRODUCT_TEXTS
} from '@/store/action-types'
import { ProductTextArt } from '@/model/products/ProductTextArt'
import ProductTextLanguagesDialog from '@/components/master-data/product/ProductTextLanguagesDialog.vue'
import {
  CreateProductPayload,
  GetProductTextsPayload, UpdateProductPayload,
  UpsertProdukteBemerkungenPayload,
  UpsertProdukteBezeichnungenPayload,
  UpsertProdukteTextePayload
} from '@/types/payload'
import { ProductUnit } from '@/model/products/ProductUnit'
import { ProductSubstitute } from '@/model/products/ProductSubstitute'
import { ProductSearchRecord } from '@/model/products/ProductSearchRecord'
import DeleteDialog from '@/components/DeleteDialog.vue'
import ProductSearchDialog from '@/components/master-data/product/ProductSearchDialog.vue'
import ProductAdditionalFields from '@/components/master-data/product/ProductAdditionalFields.vue'
import ProductNotes from '@/components/master-data/product/ProductNotes.vue'
import ProductStorageAndPricing from '@/components/master-data/product/ProductStorageAndPricing.vue'
import ProductCustomersAndSuppliers from '@/components/master-data/product/ProductCustomersAndSuppliers.vue'

interface ComponentData {
  activeTab: number
  activeTextTab1: number
  activeTextArt: number
  activeTab2: number
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string
  saveLoading: boolean
  rules: Array<Function>

  selectedProductGroupId: number | null
  productSorting: string | null
  productClassification: string | null
  productNumber: string | null
  productDescription: string | null
  productVersion: string | null

  text: string | null
  notice: string | null
  textArtList: ProductTextArt[]
  selectedTextArtId: number | null
  productTexts: any[]
  languagesDialogDescriptionData: ProductTextLanguage[]
  languagesDialogTextData: ProductTextLanguage[]
  languagesDialogNoticeData: ProductTextLanguage[]
  showProductDescriptionLanguagesDialog: boolean
  showTextLanguagesDialog: boolean
  showNoticeLanguagesDialog: boolean

  showDeleteDialog: boolean
  loading: boolean

  selectedProductId: number | undefined
  productIdIndex: number
  selectedProduct: ProductSearchRecord | null
  isEdit: boolean

  productUnitList: ProductUnit[]
  selectedProductUnitId: number | null
  duration: string | null
  ordered: string | null
  reserved: string | null
  inventoryCounts: number | null

  bestandesfuehrung: boolean
  chargenpflicht: boolean
  retrogradeAbbuchung: boolean
  sammelartikel: boolean
  seriennummernfuehrung: boolean
  seriennummernpflicht: boolean
  CE: boolean
  SEV: boolean

  productSubstitute: ProductSubstitute | null
  blocking: boolean
  showSearchDialog: boolean
}

export default Vue.extend({
  name: 'ProductWindow',

  components: {
    ProductTextLanguagesDialog,
    ProductAdditionalFields,
    ProductNotes,
    ProgressCircular,
    DeleteDialog,
    ProductSearchDialog,
    ProductStorageAndPricing,
    ProductCustomersAndSuppliers
  },

  props: {
    showDialog: Boolean,
    productGroupId: Number,
    productIdList: Array as () => number[],
    productList: Array as () => ProductSearchRecord[],
    productGroupList: Array as () => ProductGroup[]
  },

  data (): ComponentData {
    return {
      activeTab: 0,
      activeTextTab1: 0,
      activeTextArt: 0,
      activeTab2: 0,
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',
      saveLoading: false,
      rules: [(value: any): boolean | string => !!value || ''],

      selectedProductGroupId: null,
      productSorting: null,
      productClassification: null,
      productNumber: null,
      productDescription: null,
      productVersion: null,

      text: null,
      notice: null,
      textArtList: [],
      selectedTextArtId: null,
      productTexts: [],
      languagesDialogDescriptionData: [],
      languagesDialogTextData: [],
      languagesDialogNoticeData: [],
      showProductDescriptionLanguagesDialog: false,
      showTextLanguagesDialog: false,
      showNoticeLanguagesDialog: false,

      showDeleteDialog: false,
      loading: false,

      selectedProductId: undefined,
      productIdIndex: 0,
      selectedProduct: null,
      isEdit: false,

      productUnitList: [],
      selectedProductUnitId: null,
      duration: '0,000',
      ordered: '0,000',
      reserved: '0,000',
      inventoryCounts: 0,

      bestandesfuehrung: false,
      chargenpflicht: false,
      retrogradeAbbuchung: false,
      sammelartikel: false,
      seriennummernfuehrung: false,
      seriennummernpflicht: false,
      CE: false,
      SEV: false,

      productSubstitute: null,
      blocking: false,
      showSearchDialog: false
    }
  },

  computed: {
    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },

    uiLanguageList (): UiLanguageList {
      return this.$store.state.uiLanguageList
    },

    isAddButtonEnabled (): boolean {
      return true
    },

    toolbarColor (): string {
      return hexToRgba(this.$vuetify.theme.themes.light.primary)
    },

    selectedLanguageId (): number {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].syzId
    },

    getProductTitle (): string {
      if(this.selectedProduct) {
        return `${this.selectedProduct.nummer ? this.selectedProduct.nummer : ''} ${ this.selectedProduct.bezeichnung ?  this.selectedProduct.bezeichnung : ''}`
      } else {
        return ''
      }
    },

    isProductBeforeDisabled (): boolean {
      return this.productIdIndex === 0
    },

    isProductAfterDisabled (): boolean {
      return this.productIdIndex === this.productIdList.length -1
    },

    showInsertButton (): boolean {
      return securityService.isVisible(SecurityArea.Addresses, SecurityComponent.IconInsert)
    },

    isDisabledInsertButton (): boolean {
      return securityService.isDisabled(SecurityArea.Addresses, SecurityComponent.IconInsert)
    },

    showUpdateButton (): boolean {
      return securityService.isVisible(SecurityArea.Addresses, SecurityComponent.IconUpdate)
    },

    isDisabledUpdateButton (): boolean {
      return securityService.isDisabled(SecurityArea.Addresses, SecurityComponent.IconUpdate)
    },

    showDeleteButton (): boolean {
      return securityService.isVisible(SecurityArea.Addresses, SecurityComponent.IconDelete)
    },

    isDisabledDeleteButton (): boolean {
      return securityService.isDisabled(SecurityArea.Addresses, SecurityComponent.IconDelete)
    }
  },

  watch: {
    selectedProductId (newVal: number): void {
      const form: any = this.$refs['form']
      form.resetValidation()
      if(newVal !== 0) {
        this.isEdit = false
        this.setData()
      } else {
        this.activeTab = 0
        this.setData()

        this.languagesDialogDescriptionData = this.uiLanguageList.map((item: UiLanguageItem) => {
          return {
            languageId: item.syzId,
            text : ''
          }
        })

        this.languagesDialogNoticeData = this.uiLanguageList.map((item: UiLanguageItem) => {
          return {
            languageId: item.syzId,
            text : ''
          }
        })
      }
    },

    activeTab (newVal: number): void {
      let data: any = this.getRouteData()
      data.addressTab = newVal
      this.$router.push({ name: 'ProductSearch', query: { data: JSON.stringify(data) } })
    },

    activeTab2 (newVal: number): void {
      let data: any = this.getRouteData()
      data.addressTab2 = newVal
      this.$router.push({ name: 'ProductSearch', query: { data: JSON.stringify(data) } })
    },


  },

  methods: {
    onAddProductClick (): void {
      this.isEdit = true
      this.productIdIndex = 0
      this.selectedProductId = 0
      this.$emit('startCreate')
    },

    onEditProductClick (): void {
      this.isEdit = true
    },

    onDeleteProductClick (): void {
      this.showDeleteDialog = true
    },

    onProductBeforeClick (): void {
      this.productIdIndex -= 1
      this.selectedProductId = this.productIdList[this.productIdIndex]
      let data: any = this.getRouteData()
      data.productIdIndex = this.productIdIndex
      this.$router.push({name: 'ProductSearch', query: { data: JSON.stringify(data) }})
    },

    onProductAfterClick (): void {
      this.productIdIndex += 1
      this.selectedProductId = this.productIdList[this.productIdIndex]
      let data: any = this.getRouteData()
      data.productIdIndex = this.productIdIndex
      this.$router.push({name: 'ProductSearch', query: { data: JSON.stringify(data) }})
    },

    onSearchClick (): void {
      this.$emit('close')
    },

    async onCopyClick (): Promise<void> {
      try {
        const response: any = await this.$store.dispatch(COPY_PRODUCT, this.selectedProductId!)
        if(!response.IsError && response.Data) {

        } else { }
      } catch { }
    },

    onCloseDialog (): void {
      this.$emit('close')
    },

    onDeleteDialogClose (): void {
      this.showDeleteDialog = false
    },

    onDeleteDialogSave (): void {
      this.showDeleteDialog = false
      this.deleteProduct()
    },

    async deleteProduct (): Promise<void> {
      try {
        this.loading = true
        const response: AddProductResponse = await this.$store.dispatch(DELETE_PRODUCT, this.selectedProductId!)
        if (!response.IsError) {
          this.$emit('productDeleted', this.selectedProductId!)
          this.messageSnackbar = response.Result ? response.Result : this.$t('success.dataHaveBeenDeleted').toString()
          this.snackbarState = SnackbarStateEnum.Success
        } else {
          this.messageSnackbar = response.Result ? response.Result : this.$t('errors.dataCouldNotBeDeleted').toString()
          this.snackbarState = SnackbarStateEnum.Error
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeDeleted').toString()
        this.snackbarState = SnackbarStateEnum.Error
      } finally {
        this.showSnackbar = true
        this.loading = false
      }
    },

    onProductDescriptionLanguagesClick (): void {
      this.showProductDescriptionLanguagesDialog = true
    },

    async fetchProductDescriptionLanguages (): Promise<void> {
      try {
        const response: GetProductDescriptionResponse = await this.$store.dispatch(FETCH_PRODUCT_DESCRIPTION_TEXTS, this.selectedProductId!)
        if(!response.IsError && response.Data) {
          this.languagesDialogDescriptionData = response.Data.map((item: ProductDescriptionItemResponse) => {
            return {
              languageId: item.Sprache,
              text : item.Bezeichnung ? item.Bezeichnung : ''
            }
          })
        } else { }
      } catch { }
    },

    onProductDescriptionLanguagesDialogSave (data: ProductTextLanguage[]): void {
      this.languagesDialogDescriptionData = data
      this.onProductDescriptionLanguagesDialogClose()
    },

    onProductDescriptionLanguagesDialogClose (): void {
      this.showProductDescriptionLanguagesDialog = false
    },

    onTextArtChange (index: number): void {
      this.selectedTextArtId = this.textArtList[index].id
    },

    async getProductTexts (artId: number): Promise<void> {
        const payload: GetProductTextsPayload = {
          productId: this.selectedProductId!,
          artId: artId
        }

        try {
          const response: GetProductTextsResponse = await this.$store.dispatch(FETCH_PRODUCT_TEXTS, payload)
          if(!response.IsError && response.Texts) {
            const texts: ProductText[] = response.Texts
            if(artId === this.selectedTextArtId) {
              const foundText: ProductText | undefined = texts.find((item: ProductText) => item.Sprache === this.selectedLanguageId)
              this.text = foundText && foundText.Text ? foundText.Text : ''
            }
            this.productTexts.push({
              artId: artId,
              texts: texts
            })
          } else { }
        } catch { }
    },

    onTextLanguagesClick (): void {
      const foundTexts: any = this.productTexts.find((item: any) => item.artId === this.selectedTextArtId)
      if(foundTexts) {
        this.languagesDialogTextData = foundTexts.texts.map((item: ProductText) => {
          return {
            languageId: item.Sprache,
            text : item.Text ? item.Text : ''
          }
        })
      }

      this.showTextLanguagesDialog = true
    },

    onTextLanguagesDialogSave (data: ProductTextLanguage[]) {
      const foundTexts: any | undefined = this.productTexts.find((item: any) => item.artId === this.selectedTextArtId)
      if(foundTexts) {
        foundTexts.texts.forEach((item: ProductText) => {
          const foundText: ProductTextLanguage | undefined = data.find((i: ProductTextLanguage) => i.languageId === item.Sprache)
          if(foundText) {
            item.Text = foundText.text
          }
        })
      }
      this.languagesDialogTextData = data
      this.text = data.find((i: ProductTextLanguage) => i.languageId === this.selectedLanguageId) ? data.find((i: ProductTextLanguage) => i.languageId === this.selectedLanguageId)!.text : null

      this.onTextLanguagesDialogClose()
    },

    onTextLanguagesDialogClose (): void {
      this.showTextLanguagesDialog = false
    },

    onNoticeLanguagesClick (): void {
      this.showNoticeLanguagesDialog = true
    },

    onNoticeLanguagesDialogSave (data: ProductTextLanguage[]): void {
      this.languagesDialogNoticeData = data
      this.onNoticeLanguagesDialogClose()
    },

    onNoticeLanguagesDialogClose (): void {
      this.showNoticeLanguagesDialog = false
    },

    onCancelClick (): void {
      this.isEdit = false
      this.setData()
    },

    async onSaveButtonClick (): Promise<void> {
      const form: any = this.$refs['form']
      if(form.validate()) {

        if (this.isEdit && this.selectedProductId !== 0) {
          this.updateProduct()

          if (this.languagesDialogDescriptionData) {
            this.saveProductDescription()
          }

          if (this.languagesDialogNoticeData) {
            this.saveProductNotice()
          }

          if(this.productTexts) {
            this.productTexts.forEach((item: any) => {
              this.saveProductTexts(item.texts)
            })
          }
        } else {
          this.createProduct()
        }
      }
    },

    async saveProductDescription (): Promise<void> {
      const payload: UpsertProdukteBezeichnungenPayload = {
        Texts: this.languagesDialogDescriptionData.map((item: ProductTextLanguage) => {
          return {
            Product: this.selectedProductId!,
            Text: item.text,
            Language: item.languageId
          }
        })
      }

      try {
        const response: ResponseBase = await this.$store.dispatch(UPDATE_PRODUCT_DESCRIPTION_TEXTS, payload)
        if(!response.IsError) {
        } else { }
      } catch { }
    },

    async saveProductNotice (): Promise<void> {
      const payload: UpsertProdukteBemerkungenPayload =  {
        Texts: this.languagesDialogNoticeData.map((item: ProductTextLanguage) => {
          return {
            Product: this.selectedProductId!,
            Text: item.text,
            Language: item.languageId
          }
        })
      }
      try {
        const response: ResponseBase = await this.$store.dispatch(UPDATE_PRODUCT_NOTICES, payload)
        if(!response.IsError) {
        } else { }
      } catch { }
      this.onNoticeLanguagesDialogClose()
    },

    async saveProductTexts (data: ProductText[]): Promise<void> {
      const payload: UpsertProdukteTextePayload =  {
        Texts: data.map((item: ProductText) => {
          return {
            Product: this.selectedProductId!,
            Text: item.Text ? item.Text : '',
            Language: item.Sprache,
            Art: item.TextArt
          }
        })
      }

      try {
        const response: ResponseBase = await this.$store.dispatch(UPDATE_PRODUCT_TEXTS, payload)
        if(!response.IsError) {
        } else { }
      } catch { }
      this.onTextLanguagesDialogClose()
    },

    async createProduct (): Promise<void> {
      const languagesDescription: UpsertProdukteBezeichnungenPayload = {
        Texts: this.languagesDialogDescriptionData.map((item: ProductTextLanguage) => {
          return {
            Product: this.selectedProductId!,
            Text: item.text,
            Language: item.languageId
          }
        })
      }

      const languagesNotice: UpsertProdukteBemerkungenPayload = {
        Texts: this.languagesDialogNoticeData.map((item: ProductTextLanguage) => {
          return {
            Product: this.selectedProductId!,
            Text: item.text,
            Language: item.languageId
          }
        })
      }

      const payload: CreateProductPayload = {
        Sprache: this.selectedLanguageId,
        //Top part of the screen
        Gruppe: this.selectedProductGroupId!,
        Sortierung: this.productSorting!,
        Klassifizierung: this.productClassification!,
        Nummer: this.productNumber!,
        Version: this.productVersion!,
        //Weiters
        Einheit: this.selectedProductUnitId!,
        InvZaehlungen: this.inventoryCounts ? this.inventoryCounts : null,
        //Flags
        Bestandesfuehrung: this.bestandesfuehrung,
        Chargenpflicht: this.chargenpflicht,
        RetrogradeAbbuchung: this.retrogradeAbbuchung,
        Sammelartikel: this.sammelartikel,
        Seriennummernfuehrung: this.seriennummernfuehrung,
        Seriennummernpflicht: this.seriennummernpflicht,
        CE: this.CE,
        SEV: this.SEV,
        //Erstaz
        Sperrung: this.blocking,
        Ersatz: this.productSubstitute ? this.productSubstitute.id : 0,

        Bezeichnungen: languagesDescription ? languagesDescription.Texts : [],
        Bemerkungen: languagesNotice ? languagesNotice.Texts : [],
        ProduktTexte: []
      }

      try {
        this.loading = true
        const response: AddProductResponse = await this.$store.dispatch(CREATE_PRODUCT, payload)
        if (!response.IsError) {
          this.$emit('productCreated', response.ProductId)
          this.messageSnackbar = response.Result ? response.Result : this.$t('success.dataHaveBeenSaved').toString()
          this.snackbarState = SnackbarStateEnum.Success
        } else {
          this.messageSnackbar = response.Result ? response.Result : this.$t('errors.dataCouldNotBeSaved').toString()
          this.snackbarState = SnackbarStateEnum.Error
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved').toString()
        this.snackbarState = SnackbarStateEnum.Error
      } finally {
        this.showSnackbar = true
        this.loading = false
      }
    },

    async updateProduct (): Promise<void> {
      const payload: UpdateProductPayload = {
        Produkt: this.selectedProduct!.id,
        Sprache: this.selectedLanguageId,
        //Top part of the screen
        Gruppe: this.selectedProductGroupId!,
        Sortierung: this.productSorting!,
        Klassifizierung: this.productClassification!,
        Nummer: this.productNumber!,
        Version: this.productVersion!,
        //Weiters
        Einheit: this.selectedProductUnitId!,
        InvZaehlungen: this.inventoryCounts ? parseInt(this.inventoryCounts.toString()) : null,
        //Flags
        Bestandesfuehrung: this.bestandesfuehrung,
        Chargenpflicht: this.chargenpflicht,
        RetrogradeAbbuchung: this.retrogradeAbbuchung,
        Sammelartikel: this.sammelartikel,
        Seriennummernfuehrung: this.seriennummernfuehrung,
        Seriennummernpflicht: this.seriennummernpflicht,
        CE: this.CE,
        SEV: this.SEV,
        //Erstaz
        Sperrung: this.blocking,
        Ersatz: this.productSubstitute ? this.productSubstitute.id : 0
      }

      try {
        this.saveLoading = true
        const response: ResponseBase = await this.$store.dispatch(UPDATE_PRODUCT, payload)
        if (!response.IsError) {
          this.isEdit = false
          this.$emit('productEdited')
          this.messageSnackbar = response.Result ? response.Result : this.$t('success.dataHaveBeenSaved').toString()
          this.snackbarState = SnackbarStateEnum.Success
        } else {
          this.messageSnackbar = response.Result ? response.Result : this.$t('errors.dataCouldNotBeSaved').toString()
          this.snackbarState = SnackbarStateEnum.Error
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved').toString()
        this.snackbarState = SnackbarStateEnum.Error
      } finally {
        this.showSnackbar = true
        this.saveLoading = false
      }
    },

    onSearchProductClick (): void {
      this.showSearchDialog = true
    },

    onSelectedProduct (data: ProductSearchRecord): void {
      this.getProductSubstitute(data.id)
      this.closeSearchDialog()
    },

    closeSearchDialog (): void {
      this.showSearchDialog = false
    },

    setData (): void {
      const foundProduct: ProductSearchRecord | undefined = this.productList.find((item: ProductSearchRecord) => item.id === this.selectedProductId!)
      if(foundProduct) {
        this.selectedProduct = foundProduct

        const foundProductGroup: ProductGroup | undefined = this.productGroupList.find((item: ProductGroup) => item.code === this.selectedProduct!.pGrp)

        this.selectedProductGroupId = foundProductGroup ? foundProductGroup.id : null
        this.productSorting = this.selectedProduct.sortierung
        this.productClassification = this.selectedProduct.klassifizierung
        this.productNumber = this.selectedProduct.nummer
        this.productDescription = this.selectedProduct.bezeichnung
        this.productVersion = this.selectedProduct.version
        this.selectedProductUnitId = this.selectedProduct.einheit
        this.duration = parseFloat(this.selectedProduct.bestand.toString()).toFixed(3)
        this.ordered = parseFloat(this.selectedProduct.bestellt.toString()).toFixed(3)
        this.reserved = parseFloat(this.selectedProduct.reserviert.toString()).toFixed(3)
        this.inventoryCounts = this.selectedProduct.invZaehlungen !== null ? this.selectedProduct.invZaehlungen : 0
        this.bestandesfuehrung = this.selectedProduct.bestandesfuehrung
        this.chargenpflicht = this.selectedProduct.chargenpflicht
        this.retrogradeAbbuchung = this.selectedProduct.retrogradeAbbuchung
        this.sammelartikel = this.selectedProduct.sammelartikel
        this.seriennummernfuehrung = this.selectedProduct.seriennummernfuehrung
        this.seriennummernpflicht = this.selectedProduct.seriennummernpflicht
        this.CE = this.selectedProduct.ce
        this.SEV = this.selectedProduct.sev
        this.blocking = this.selectedProduct.gesperrt

        this.fetchProductDescriptionLanguages()
        this.getProductNotices()
        this.productTexts = []
        this.textArtList.forEach((item: ProductTextArt) => {
          this.getProductTexts(item.id)
        })
      } else {
        this.selectedProduct = null

        this.selectedProductGroupId = this.productGroupId ? this.productGroupId : null
        this.productSorting = null
        this.productClassification = null
        this.productNumber = null
        this.productDescription = null
        this.productVersion = null
        this.selectedProductUnitId = this.productUnitList && this.productUnitList[0] ? this.productUnitList[0].id : null
        this.duration = '0.000'
        this.ordered = '0.000'
        this.reserved = '0.000'
        this.inventoryCounts = 0
        this.bestandesfuehrung = false
        this.chargenpflicht = false
        this.retrogradeAbbuchung = false
        this.sammelartikel = false
        this.seriennummernfuehrung = false
        this.seriennummernpflicht = false
        this.CE = false
        this.SEV = false
        this.productSubstitute = null
        this.blocking = false

        this.text = null
        this.notice = null
        this.productTexts = []
        this.languagesDialogTextData = []
      }
    },

    async fetchTextArt (): Promise<void> {
      try {
        const response: ProductTextArtResponse = await this.$store.dispatch(FETCH_PRODUCT_TEXT_ART_LIST)
        if(!response.IsError && response.Data) {
          this.textArtList = ProductTextArt.createFromResponse(response.Data)
          this.selectedTextArtId = this.textArtList[this.activeTextArt].id
          if(this.selectedProductId !== 0) {
            this.productTexts = []
            await this.textArtList.forEach((item: ProductTextArt) => {
              this.getProductTexts(item.id)
            })

            const foundTexts: any = this.productTexts.find((item: any) => item.artId === this.selectedTextArtId)
            if(foundTexts) {
              this.languagesDialogTextData = foundTexts.texts.map((item: ProductText) => {
                return {
                  languageId: item.Sprache,
                  text : item.Text ? item.Text : ''
                }
              })
            }
          }
        } else { }
      } catch { }
    },

    async getProductNotices (): Promise<void> {
      try {
        const response: GetProductNoticesResponse = await this.$store.dispatch(FETCH_PRODUCT_NOTICES, this.selectedProductId!)
        if(!response.IsError && response.Data) {
          this.languagesDialogNoticeData = response.Data.map((item: ProductNoticeResponse) => {
            return {
              languageId: item.Sprache,
              text : item.Bemerkung ? item.Bemerkung : ''
            }
          })
          const foundText: ProductNoticeResponse | undefined = response.Data.find((item: ProductNoticeResponse) => item.Sprache === this.selectedLanguageId)
          this.notice = foundText && foundText.Bemerkung ? foundText.Bemerkung : ''
        } else { }
      } catch { }
    },

    async getUnitList (): Promise<void> {
      try {
        const response: ProductUnitResponse = await this.$store.dispatch(FETCH_PRODUCT_UNIT_LIST)
        if(!response.IsError && response.Data) {
          this.productUnitList = ProductUnit.createListFromResponse(response.Data)
          if(!this.selectedProductUnitId && this.productUnitList && this.productUnitList[0]) {
            this.selectedProductUnitId = this.productUnitList[0].id
          }
        } else { }
      } catch { }
    },

    async getProductSubstitute (payload: number): Promise<void> {
      try {
        const response: ProductSubstituteResponse = await this.$store.dispatch(FETCH_PRODUCT_SUBSTITUTE, payload)
        if(!response.IsError && response.Data) {
          this.productSubstitute = ProductSubstitute.createFromResponse(response.Data)
        } else { }
      } catch { }
    },

    getRouteData (): Object {
      let data: any = undefined
      try {
        //@ts-ignore
        data = this.$route && this.$route.query && this.$route.query.data ? JSON.parse(this.$route.query.data) : {}
      } catch (e) {
        data = {}
      }

      return data
    },

    setDataFromRoute () {
      let data: any = this.getRouteData()

      if (this.$route.path === '/product') {
        this.productIdIndex = data && data.productIdIndex ? data.productIdIndex : 0
        if (this.productIdList[this.productIdIndex]) {
          this.selectedProductId = this.productIdList[this.productIdIndex]
        } else {
          this.selectedProductId = this.productIdList[0]
        }
        this.activeTab = data.addressTab
        this.activeTab2 = data.addressTab2
      }
    }
  },

  async mounted (): Promise<void> {
    this.setDataFromRoute()
    if(this.selectedProductId !== 0) {
      //this.setData()
    } else {
      if(this.productGroupId) {
        this.selectedProductGroupId = this.productGroupId
      }

      this.languagesDialogDescriptionData = this.uiLanguageList.map((item: UiLanguageItem) => {
        return {
          languageId: item.syzId,
          text : ''
        }
      })

      this.languagesDialogNoticeData = this.uiLanguageList.map((item: UiLanguageItem) => {
        return {
          languageId: item.syzId,
          text : ''
        }
      })
    }

    this.fetchTextArt()
    this.getUnitList()

    if(this.selectedProductId !== 0 && this.selectedProduct && this.selectedProduct.ersatz !==0) {
      this.getProductSubstitute(this.selectedProduct!.ersatz)
    }
  }
})
